import { falAngleRight } from 'shared/@generated/icons/falAngleRight';
import React from 'react';
import { View } from 'react-native';
import { Text } from 'shared/components/text';
import { Link } from 'shared/components/link';
import { Icon } from 'shared/components/icon';
import type { BreadcrumbProps } from './index';
import { clsx } from 'clsx';
import { buildBreadcrumbSchema } from './breadcrumb-schema';
import { serializeJsonLd } from 'shared/library/json-ld';

const Breadcrumb = ({
  items,
  separator,
  className = '',
  itemClassName = '',
  separatorClassName = '',
}: BreadcrumbProps) => {
  const filteredItems = items.filter((item) => item.text !== null);
  const schema = buildBreadcrumbSchema(items);

  const defaultSeparator = (
    <Icon
      icon={falAngleRight}
      className={clsx('text-brand-brown-dark/70 size-2.5', separatorClassName)}
    />
  );

  return (
    <>
      {schema && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: serializeJsonLd(schema) }}
        />
      )}
      <View
        className={clsx(
          'min-w-0 flex-row flex-nowrap items-center gap-1.5 overflow-hidden',
          className,
        )}
      >
        {filteredItems.map((item, index) => {
          const isLastItem = index === filteredItems.length - 1;
          const layoutClassName = isLastItem ? 'min-w-0 flex-1 overflow-hidden' : 'shrink-0';

          return (
            <React.Fragment key={index}>
              {item.href ? (
                <Link
                  href={item.href}
                  numberOfLines={1}
                  containerClassName={layoutClassName}
                  textClassName={clsx(
                    'text-brand-brown-dark/70 min-w-0',
                    isLastItem && 'flex-1',
                    itemClassName,
                  )}
                >
                  {item.text}
                </Link>
              ) : (
                <Text
                  numberOfLines={1}
                  className={clsx('text-brand-brown-dark/70', layoutClassName, itemClassName)}
                >
                  {item.text}
                </Text>
              )}

              {index < filteredItems.length - 1 && (
                <View className={'shrink-0'}>{separator ?? defaultSeparator}</View>
              )}
            </React.Fragment>
          );
        })}
      </View>
    </>
  );
};

export { Breadcrumb };
